<template>
  <div class="send_mfa_area max-width-800 padding-top padding-bottom">
    <template v-if="!show_verify_mfa_page">
      <div class="row">
        <div class="col">
          <h2 class="mb-5">How would you like to receive your code?</h2>
          <select v-model="mfa_type" v-on:change="clearErrors()">
            <option hidden disabled selected value>Select One</option>
            <option value="email">Email</option>
            <option value="text">Text</option>
          </select>
        </div>
        <div class="col text-center">
          <img
            style="max-width: none"
            class="img-responsive"
            src="\images\mfa-security-icon.png"
            title="MFA Security Image"
          />
        </div>
      </div>

      <div class="py-5">
        <div class="row">
          <div class="col pb-3 text-center">
            <p
              class="my-1"
              :class="has_error ? 'error-message' : 'success-message'"
            >
              {{ this.message }}
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col text-center">
            <button
              type="button"
              :disabled="mfa_type === '' || is_loading ? true : false"
              :class="
                mfa_type === '' || is_loading ? 'button-grey' : 'button-green'
              "
              class="btn px-5"
              v-on:click="sendCode()"
            >
              <template v-if="is_loading">Sending code...</template>
              <template v-else>Send Code</template>
            </button>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <VerifyMFAComponent
        :user_id="user_id"
        :redirect="redirect"
        :email="email"
        :password="password"
        :mfa_type="mfa_type"
      />
    </template>
  </div>
</template>

<script>
  import VerifyMFAComponent from '~/components/user/mfa/VerifyMFAComponent.vue';
  export default {
    name: 'SendMFAComponent',
    props: {
      user_id: Number,
      redirect: String,
      email: String,
      password: String,
    },

    components: {
      VerifyMFAComponent,
    },

    data: function () {
      return {
        is_loading: false,
        show_verify_mfa_page: false,
        mfa_type: '',
        message: '',
        has_error: false,
      };
    },

    mounted() {},

    methods: {
      clearErrors: function () {
        this.has_error = false;
        this.message = '';
      },
      sendCode: function () {
        this.is_loading = true;
        this.has_error = false;
        this.message = '';

        // this.show_verify_mfa_page = true;

        axios
          .post('/api/v1/user/mfa/send', {
            user_id: this.user_id,
            mfa_type: this.mfa_type,
          })
          .then((success) => {
            this.has_error = !success.data.success;
            this.is_loading = false;

            if (success.data.success) {
              this.show_verify_mfa_page = true;
            } else {
              this.message = success.data.message;
            }
          })
          .catch((error) => {
            this.has_error = true;
            this.is_loading = false;
            this.message =
              'Error trying to send verification code. Please contact support.';
          });
      },
    },
  };
</script>
